var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var SvgJS = require('svgjs')
// special version to support hammer.js in SVG
var SvgHammer = require('./svg.hammer.js')
//
var DimmingSection = require('./section.js').Section
var RgbSection = require('./section.js').RgbSection
var RgbwSection = require('./section.js').RgbwSection

var RoutineComposer = Marionette.Object.extend({
  helpers: {
  },
  // converts the percent position to pixel position
  getPixelPosition: function (x, y) {
    var self = this
    var newX = self.composerStage.x() + ((self.composerStage.width() / 100) * x)
    var newY = self.composerStage.y() + ((self.composerStage.height() / 100) * y)
    return {x: newX, y: newY}
  },
  getPercentPosition: function (x, y, relative) {
    var self = this

    var pos = {x: x, y: y}
    if (relative) {
      pos = self.getRelPosition(pos.x, pos.y)
    }

    var percentX = (pos.x / self.composerStage.width()) * 100
    var percentY = 0
    return {x: percentX, y: percentY}
  },
  getRelPosition: function (x, y) {
    var self = this

    let newX = x - self.composerStage.x()
    let newY = y - self.composerStage.y()
    return {x: newX, y: newY}
  },

  // returns the percentual width of all the sections except the given id
  getOtherSectionsWidth: function (id) {
    var self = this

    var totalWidth = self.getTotalSectionsWidth()
    totalWidth = totalWidth + self.startTime
    return totalWidth - self.getSectionById(id).width
  },

  // get the percentual width of all the sections
  getTotalSectionsWidth: function () {
    var self = this

    return _.reduce(self.sections, function (sum, o) {
      return sum + o.width
    }, 0)
  },
  drawHandler: function () {
    var self = this

    // calculate handler
    var touchRadius = self.options.touchRadius
    var buttonRadius = self.options.buttonRadius
    var buttonOffset = (touchRadius - buttonRadius) / 2

    var group = self.draw.group().size(touchRadius, touchRadius).style('cursor', 'pointer')
    group.addClass('section-handler')

    var handlerTouch = self.draw.ellipse(touchRadius, touchRadius).opacity(0)
    var handlerButton = self.draw.ellipse(buttonRadius, buttonRadius).move(buttonOffset, buttonOffset).stroke({ width: 2, color: self.options.mainColor }).fill({ color: '#ffffff'})
    handlerButton.addClass('section-handler__button')

    var handlerSelected = self.draw.ellipse(buttonRadius - 8, buttonRadius - 8).move(buttonOffset + 4, buttonOffset + 4).fill({ color: self.options.mainColor}).opacity(0)
    handlerSelected.addClass('section-handler__indicator')

    group.add(handlerTouch)
    group.add(handlerButton)
    group.add(handlerSelected)

    return group
  },
  prepareSection: function (section) {
    var self = this

    if (this.options.type === 'color') {
      self.sectionBlocks[section.id] = new RgbSection({sectionId: section.id, parent: self, stage: self.draw, mainOptions: self.options})
    } else if (this.options.type === 'color_rgbw') {
      self.sectionBlocks[section.id] = new RgbwSection({sectionId: section.id, parent: self, stage: self.draw, mainOptions: self.options})
    } else {
      self.sectionBlocks[section.id] = new DimmingSection({sectionId: section.id, parent: self, stage: self.draw, mainOptions: self.options})
    }

    // draw handler
    self.sectionHandlers[section.id] = self.drawHandler()
    self.sectionHandlers[section.id]['selected'] = false

    self.sectionHandlers[section.id].hammer()
    self.sectionHandlers[section.id].on('pan', function (e) { self.dragHandler(e, this) })
    self.sectionHandlers[section.id].on('tap', function (e) { self.tapHandler(e, this) })

    self.sectionHandlers[section.id].on('panend', function (e) { self.update() })


    self.sectionHandlers[section.id].remember('id', section.id)

    self.handlersGroup.add(self.sectionHandlers[section.id])
    //
  },
  /**
   * Takes care of moving and resizing the sections and section handles
   * @return {[type]} [description]
   */
  updateSections: function () {
    var self = this

    var composerBaseY = self.composerStage.y() + self.composerStage.height()
    var linePoints = []
    var originPosition = (self.composerStage.width() / 100) * self.startTime

    for (var i = 0; i < self.sections.length; i++) {
      var section = self.sections[i]
      var sectionId = section.id

      var width = (self.composerStage.width() / 100) * section.width
      var height = (self.composerStage.height() / 100) * section.height

      var newX = self.composerStage.x()
      var newY = composerBaseY - height
      // var newY = self.composerStage.height() + self.composerStage.y()

      var sectionHandler = self.sectionHandlers[section.id]
      var sectionBlock = self.sectionBlocks[section.id]

      sectionBlock.size(width, height)

      // self.sectionBlocks[section.id].move(0, (self.options.height - self.sectionBlocks[section.id].height())).width(width).height(height)
      // self.sectionBlocks[section.id].move(0, 0).width(width).height(height)

      // if this is the first section
      if (i === 0) {
        section['start'] = self.startTime
        newX = newX
        sectionBlock.move(newX + originPosition, newY)
        sectionHandler.move(((newX + width + originPosition) - (sectionHandler.width() / 2)), newY - (sectionHandler.height() / 2))

        // capture line points
        linePoints.push([newX + originPosition, composerBaseY])
        linePoints.push([newX + originPosition, newY])
        linePoints.push([(newX + originPosition + width), newY])

      // if this are relative sections
      } else {
        section['start'] = self.sections[i - 1].start + self.sections[i - 1].width

        var prevSectionId = self.sections[i - 1].id
        var prevSectionBlock = self.sectionBlocks[prevSectionId]
        newX = prevSectionBlock.x() + prevSectionBlock.width()

        sectionBlock.move(newX, newY)
        sectionHandler.move(((newX + width) - (sectionHandler.width() / 2)), newY - (sectionHandler.height() / 2))

        // capture line points
        linePoints.push([newX, newY])
        linePoints.push([(newX + width), newY])
      }

      //
      var selectionIndicator = sectionHandler.get(2)
      if (sectionHandler.selected) {
        selectionIndicator.opacity(1)
      } else {
        selectionIndicator.opacity(0)
      }
      //
    }

    if (self.sections.length == 1) {
      linePoints.push([(newX + width + originPosition), composerBaseY])
    } else if (self.sections.length > 1) {
      linePoints.push([(newX + width), composerBaseY])
    }

    self.theLine.plot(linePoints)

    //
    if (self.sections <= 0) {
      self.originHandler.move(-99999, -99999)
    } else {
      // update line
      var firstSection = self.sectionBlocks[ self.sections[0].id ]
      self.originHandler.move(firstSection.x() - (self.options.touchRadius / 2), composerBaseY - (self.options.touchRadius / 2))
    }
    //
  },
  update: function () {
    var self = this
    self.updateSections()



    self.debouncedUpdateNotify()
    console.log('update')
  },

  updateNotify: function() {

    // triggers a message with the current routine, this way the parent view
    // can absorb the routine
    this.trigger('updated', {
 

    })
    console.log('updatenotify');
  },
  addSections: function (sections) {
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i]
      this.addSection(section)
    }

  },
  getRelativeSeconds: function (time) {
    var relativeSeconds = time - this.options.rangeMs.rangeStartTime
    if (relativeSeconds < 0) relativeSeconds = 0
    return relativeSeconds
  },
  getPercentTime: function (percent) {
    var relativeSeconds = (this.options.rangeMs.rangeDuration / 100) * percent
    // console.log(relativeSeconds)
    return this.options.rangeMs.rangeStartTime + relativeSeconds
  },
  getTimePercent: function (time) {
    var relativeTime = this.getRelativeSeconds(time)
    var percentTime = (relativeTime / this.options.rangeMs.rangeDuration) * 100
    return percentTime
  },
  // converts an routine to a sectionobject and builds the graph
  setRoutine: function (routine) {
    console.log('oioi')
    console.log(routine)
    this.reset();
    
    var sectionsObject = []
    var counter = 0

    for (var i = 0; i < routine.length; i++) {
      var subRoutine = routine[i]
      var prevSubRoutine = routine[i - 1]
      var prevSection = sectionsObject[i - 1]

      // default width
      var width = 0
      var height = subRoutine.value
      if (['color','color_rgbw'].indexOf(this.options.type) > -1) {
        height = 100
      }
      // set the begin time of the routine to the start time of the first subroutine
      if (i == 0) this.startTime = this.getTimePercent(subRoutine.time)

      // because we reached the following time event, now we can set the width of the previous section
      if (i > 0) prevSection['width'] = this.getTimePercent(subRoutine.time) - this.getTimePercent(prevSubRoutine.time)

      // prevent the last routine from being drawn, because this is an end indicator
      if (i === routine.length - 1) continue

      // add to the sectionsobject
      sectionsObject[i] = {
        id: subRoutine.id,
        width: width,
        height: height,
        properties: subRoutine.properties
      }
    }

    this.addSections(sectionsObject)
  },
  updateSection: function (id, data) {
    if (!id) return false

    let section = this.getSectionById(id)
    section = _.assign(section,data);
    this.updateSections()
  },
  removeAllSections: function() {
    this.deselectAllHandlers()
  
    _.forEach(this.sectionHandlers, function (handler) {
      handler.selected = false
      handler.remove()

    })

    _.forEach(this.sectionBlocks, function (section) {
      section.remove()
    })

    this.sectionBlocks = []
    this.sectionHandlers = []
    this.sections = []

    this.update();
  },
  removeSection: function (id) {
    if (!id) return false
    var section = this.sectionBlocks[id]
    section.remove()

    var sectionHandler = this.sectionHandlers[id]
    sectionHandler.remove()
    this.sections.splice(this.getIndexById(id), 1)
    delete this.sectionBlocks[id]
    this.update()
    this.deselectAllHandlers()
    


  },
  getProperties: function (sectionId) {
    var sectionKey = _.findKey(this.sections, { 'id': sectionId })
    return this.sections[sectionKey].properties
  },
  addSection: function (inSection, select) {
    var self = this
    self.idCounter++

    var defaultSection = {
      id: self.idCounter,
      height: 100,
      width: self.getTimePercent(60*60),
      properties: {}
    }

    var section = _.extend(defaultSection, inSection)

      // prevent adding to many sections
    if ((self.getTotalSectionsWidth() + section.width) > 100) return false

    if (!section.id) {
      section.id = self.idCounter;
    }
    section.id = section.id.toString()
    var prevSection = this.sections.slice(-1)[0]

    self.sections.push(section)

    self.prepareSection(section)

    self.update()
  },
  drawVerticalScale: function (x, y, height, steps) {
    var self = this
    var steps = 11
    var xOffset = 40
    // draw scale
    for (var i = 0; i < steps; i++) {
      var stepX = x - xOffset
      var stepY = parseInt(((height / (steps - 1)) * i) + y)
      var stepRadius = 4
      var stepHeight = 0

      var mainStep = false

      // add bigger step in begin end and on midnight
      if (i == 0 || (i + self.options.rangeStartTime) === 24 || i == self.options.rangeDuration) mainStep = true

      if (mainStep) {
        stepHeight = 10
      }

      self.draw.ellipse(stepRadius, stepRadius).move(stepX - (stepRadius / 2), stepY - (stepRadius / 2)).fill({ color: '#ABABAB' })

      // label
      var value = (100 - (i * 10)) + '%'

      var label = self.draw.text(value).move(stepX - 30, stepY - 9)
      // var label = self.draw.text('0AM').move(stepX, y + 200)
      label.attr('alignment-baseline', 'middle')
      label.attr('text-anchor', 'middle')
      label.addClass('routine-composer__vertical-label')
      label.font({
        fill: '#ABABAB'
      })
    }
  },
  drawHorizontalScale: function (x, y, width, steps) {
    var self = this
    var yOffset = 15
    // draw scale
    for (var i = 0; i <= self.options.rangeDuration; i++) {
      var stepX = parseInt(((width / self.options.rangeDuration) * i) + x)
      var stepHeight = 5

      var mainStep = false

      // add bigger step in begin end and on midnight
      if (i == 0 || (i + self.options.rangeStartTime) === 24 || i == self.options.rangeDuration) mainStep = true

      if (mainStep) {
        stepHeight = 10
      }

      self.draw.line(stepX, (y + yOffset) + stepHeight, stepX, (y + yOffset)).stroke({ width: 2, color: '#ABABAB' })

      if (mainStep) {
        var value = (self.options.rangeStartTime + i)
        var timeLabel = ':00'
        if (value > 24) value -= 24
        var label = self.draw.text(value + timeLabel).move(stepX, y + 40)
        // var label = self.draw.text('0AM').move(stepX, y + 200)
        label.attr('alignment-baseline', 'middle')
        label.attr('text-anchor', 'middle')
        label.addClass('routine-composer__horizontal-label')
        label.font({
          fill: '#ABABAB'
        })
      }
    }
  },
  deselectAllHandlers: function () {
    _.forEach(this.sectionHandlers, function (handler) {
      handler.selected = false
    })
    this.update()
    this.trigger('deselected')
  },
  triggerSelectedHandler: function (id) {
    var section = this.getSectionById(id)

    this.trigger('selected', {
      id: id,
      startTime: this.getPercentTime(section.start),
      endTime: this.getPercentTime(section.start + section.width),
      properties: section.properties,
      height: section.height

    })
  },
  selectHandler: function (id) {
    if (id === 'origin') {
      var section = this.sections[0]

      this.triggerSelectedHandler(section.id)

      return false
    }
    // disable the selected
    _.forEach(this.sectionHandlers, function (handler) {
      if (id !== handler.remember('id')) handler.selected = false
    })

    this.sectionHandlers[id].selected = true
    this.triggerSelectedHandler(id)
  },
  setProperty: function (sectionId, properties) {
    console.log('setProperty')
    console.log(sectionId);
    var section = this.getSectionById(sectionId)
    section.properties = _.assign(section.properties, properties)
    this.sectionBlocks[sectionId].refresh()
  },
  sectionBlockTapHandler: function (e, node) {
    e.preventDefault()
    var handleId = node.remember('id')
  },
  tapHandler: function (e, node) {
    e.preventDefault()
    var handleId = node.remember('id')
    this.selectHandler(handleId)
    this.update()
  },


  dragHandler: function (e, node) {
    var self = this
    e.preventDefault()
 
    
    var handleId = node.remember('id')
    // if (handleId !== 'origin') handleId = parseInt(handleId)
    var handle = node

    if (!this.selected) this.selectHandler(handleId)

    // determine the x and y position relative to the page
    var x = e.detail.x - self.svgElement.getBoundingClientRect().left
    var y = e.detail.y - self.svgElement.getBoundingClientRect().top

    if (x < 0) x = 0
    if (y < 0) y = 0

    if (!self.options.verticalDimension) y = 0

    var areaBuffer = 40
    var composerStageExceeded = false

    // constraint the x-axis
    if (x <= self.composerStage.x()) x = self.composerStage.x()
    if (x >= self.composerStage.x() + self.composerStage.width()) x = self.composerStage.x() + self.composerStage.width()
    // constraint the y-axis
    if (y <= self.composerStage.y()) y = self.composerStage.y()
    if (y >= self.composerStage.y() + self.composerStage.height()) y = self.composerStage.y() + self.composerStage.height()


    // limit to 5 mins
    let percentage = self.getPercentPosition(x,y,true);
    let percentTimeSeconds = self.getPercentTime(percentage.x);

    var coeff = 60 * 5;

     // find the nearest second interval based on the coeff, for example 5s
    let nearestSecondInterval = Math.round(percentTimeSeconds / coeff) * coeff;
    let nearestPosition = self.getPixelPosition(self.getTimePercent(nearestSecondInterval))

    x = nearestPosition.x
    // console.log(self.getPixelPosition(self.getTimePercent(nearestSecondInterval)));
    // let hmm = self.getPixelPosition(percentTimeSeconds/1000);


    // console.log(    self.getRelPosition(hmm.x))
  //  let nearestAsPixel = self.getPixelPosition(self.getTimePercent(percentTimeSeconds));
    // console.log(x)
    // console.log(nearestAsPixel)
// var dt = new Date('01/01/2000 0:00')
//     dt.setSeconds(test)
//     console.log(dt.getSeconds())
    // last handler constraint, prevent the whole setup from exceeding 100%
    var lastHandle = self.sectionHandlers[ self.sections[self.sections.length - 1].id ]

    var handleX = x - (handle.width() / 2)
    var handleY = y - (handle.height() / 2)


    // isRoutineValid()
    if (handleId === 'origin') {
      // calculate the percentage of the dragged origin
      // var percentX = (x - self.composerStage.x()) / self.composerStage.width()
      var percentX = self.getPercentPosition(x, 0, true).x
      if (percentX + self.getTotalSectionsWidth() > 100) {
        percentX = 100 - self.getTotalSectionsWidth()
      }

      self.startTime = percentX
      handle.x(handleX)
      self.updateSections()
    } else {
      self.dragSection(handleId, x, y, function (err, done) {
        if (err) {
        }

      // handle.move(handleX, handleY)
      })
    }
  },
  getPrevSection: function (id) {
    return false
  },
  dragSection: function (id, x, y, callback) {
    var self = this

    var sectionKey = _.findKey(self.sections, { 'id': id })

    var originPosition = (self.composerStage.width() / 100) * self.startTime

    var offsetX = 0

    // convert the x and y coordinate to the composer stage
    x = x - self.composerStage.x()
    y = y - self.composerStage.y()

    // // substract
    if (sectionKey == 0) {
      // console.log(sectionKey - 1)
      x = x - originPosition
    } else {
      var prevSection = self.sectionBlocks[ self.sections[sectionKey - 1].id ]
      offsetX = (prevSection.x() + prevSection.width()) - self.composerStage.x()
    }

    var xPercent = ((x - offsetX) / self.composerStage.width()) * 100
    // calculate if this is going to fit
    var maxWidth = (100 - self.getOtherSectionsWidth(id))
    var minWidth = 100 / self.options.rangeDuration

    if (xPercent > maxWidth) {
      xPercent = maxWidth
    // callback(true)
    } else if (xPercent < minWidth) {
      xPercent = minWidth
    }

    var yPercent = ((-y + self.composerStage.height()) / self.composerStage.height()) * 100
    self.sections[sectionKey].width = xPercent
    self.sections[sectionKey].height = yPercent

    // self.sections[sectionKey].height = ((-y + self.options['height']) / self.options['height']) * 100

    // // check if the sections don't exceed the max width

    // update the section
    self.updateSections()

    return callback(null, true)
  },
  getIndexById: function (id) {
    return _.findKey(this.sections, { 'id': id })
  },
  getSectionById: function (id) {
    return _.find(this.sections, function (o) { return o.id === id })
  },
  restrictTime: function(value) {
    // time restriction is necessary because otherwise there is a time overlap
    if (value < 129600) {
      return value;
    }
    return 129599;
  },
  exportRoutine: function () {
    var routine = []

    var time = this.startTime

    // routine.push({
    //   time: this.getPercentTime(time),
    //   value: 0
    // })

    for (var i = 0; i < this.sections.length; i++) {
      var section = this.sections[i]
      routine.push({
        time: this.restrictTime(parseInt(this.getPercentTime(time))),
        value: parseInt(section.height),
        properties: section.properties
      })

      time = time + section.width
    }

    // if a rountine is created at a stopper to end the routine
    // for instance when a dimming is set, after the dimming a 0 is given
    // to turn of the routine
    if (routine.length > 0) {
      routine.push({
        time: this.restrictTime(parseInt(this.getPercentTime(time))),
        value: 0,
        properties: {}
      })
    }

    console.log(routine);

    return routine
  },
  reset: function() {
    var self = this

    self.removeSections();

    // self.idCounter = 0
    // self.sections = []

    // self.sectionBlocks = {}
    // self.sectionHandlers = {}

    // self.update();

  },
  initSections: function() {
    var self = this

    for (var i = 0; i < self.sections.length; i++) {
      var section = self.sections[i]
      self.prepareSection(section)
    }
  },
  removeSections: function() {
    var self = this

    for (var i = 0; i < self.sections.length; i++) {
      console.log(i)
      var section = self.sections[i]

      var sectionBlock = this.sectionBlocks[section.id]
      sectionBlock.remove()
  
      var sectionHandler = this.sectionHandlers[section.id]
      sectionHandler.remove()
      // this.sections.splice(this.getIndexById(id), 1)
      // delete this.sectionBlocks[id]
      // this.update()
      // this.deselectAllHandlers()

      // self.removeSection(section.id)
      // console.log(section)
    }

    self.idCounter = 0
    self.sections = []

    self.sectionBlocks = {}
    self.sectionHandlers = {}

    this.update()
    this.deselectAllHandlers()
  },
  initialize: function (options) {
 
    var self = this
    // var config = App.config.maps
    var defaultOptions = {
      rangeStartTime: 0,
      rangeDuration: 24, // hours
      touchRadius: 40,
      buttonRadius: 20,
      verticalDimension: true,
      sectionDefaultHeight: 50,
      mainColor: '#FFC700',
      sectionColor: '#FFEBC5',
      sectionBorderColor: '#FFE49C'
    // rangeMarkerInterval: 1,
    // rangeMarkers: 10,
    // radius: 85,
    // digits: 0
    }

    self.options = _.extend(defaultOptions, options)

    if (self.options.type === 'color' || self.options.type === 'color_rgbw') {
      self.options.verticalDimension = false
    // self.options.mainColor = '#000000'
    }
    // calculate times
    var rangeStartTime = self.options.rangeStartTime * 3600
    var rangeEndTime = (self.options.rangeStartTime + self.options.rangeDuration) * 3600

    self.options['rangeMs'] = {
      rangeStartTime: rangeStartTime,
      rangeEndTime: rangeEndTime,
      rangeDuration: rangeEndTime - rangeStartTime
    }

    self.startTime = 0;

    // prepare
    self.svgElement = options.element
    self.boundingBox = self.svgElement.getBoundingClientRect()

    var width = self.boundingBox.width
    var height = self.boundingBox.height
    // var width = 800
    // var height = 400

    self.options['width'] = width
    self.options['height'] = height
    self.options['cx'] = width / 2
    self.options['cy'] = 120

    // sections

    self.idCounter = 0
    self.sections = []

    self.sectionBlocks = {}
    self.sectionHandlers = {}


    self.draw = SvgJS(self.svgElement).spof().size(width, height)
    self.viewbox = self.draw.viewbox(0, 0, width, height)

    var stage = self.draw.rect(width, height).attr({ fill: '#FAFAF9' })
    self.draw.addClass('routine-composer--' + self.options.type)

    var composerTopPadding = 60
    var composerLeftPadding = 130
    var composerRightPadding = 50
    var composerHeight = 280

    if (!self.options.verticalDimension) {
      composerLeftPadding = 50
    }

    var composerWidth = width - (composerLeftPadding + composerRightPadding)

    // the stage on which the composer is drawn
    // //var composerWidth =

    self.composerStage = self.draw.rect(composerWidth, composerHeight).move(composerLeftPadding, composerTopPadding).opacity(0)
    self.drawHorizontalScale(self.composerStage.x(), (self.composerStage.y() + self.composerStage.height()), self.composerStage.width())

    if (self.options.verticalDimension) {
      self.drawVerticalScale(self.composerStage.x(), self.composerStage.y(), self.composerStage.height())
    }

    stage.on('click', _.bind(self.deselectAllHandlers, self))
    self.composerStage.on('click', _.bind(self.deselectAllHandlers, self))
    self.sectionsGroup = self.draw.group()

    self.theLine = self.draw.polyline().fill('none').stroke({ width: 2, color: self.options.mainColor})
    self.theLine.addClass('routine-composer__line')
    self.handlersGroup = self.draw.group()

    // checks to see if the current routine doesn;t exceed the limits
    // var isRoutineValid = function () {
    //   var total = _.reduce(self.sections, function (sum, o) {
    //     return sum + o.width
    //   }, 0)

    //   if ((total + self.startTime) > 100) {
    //     return false
    //   } else {
    //     return true
    //   }
    // }

    //
    self.initSections();
 

    // draw the initial handler
    self.originHandler = self.drawHandler()
    self.originHandler.move(-9999, -9999)
    self.originHandler['selected'] = false
    self.originHandler.remember('id', 'origin')

    self.originHandler.hammer()
    self.originHandler.on('pan', function (e) { self.dragHandler(e, this) })
    // self.originHandler.on('pan', function (e) { 
    //   console.log('aa')
    //   console.log(e);
    //  })

    // self.originHandler.on('panend', function (e) { 
    //   console.log("oeh")
    //  })


    // }

    self.debouncedUpdateNotify = _.debounce(self.updateNotify, 100);

    self.updateSections()
  }
})

module.exports = RoutineComposer



// WEBPACK FOOTER //
// ./js/components/routine-composer/composer/index.js